import React from 'react'
import type { Maybe } from '@pylot-data/pylotschema'
import s from '@pagestyles/Blog.module.scss'
import {
    CMSBlockValueGet,
    CMSConfigConst,
    getCMSBlock
} from '@components/common/CMSBlockConst/cms-block-util'
import { CmsBlock } from '@pylot-data/fwrdschema'
import { AlfaRichContent as RichContent } from '@components/alfakher/pylot-rich-content'
import { ProductItem } from '@components/common/ProductTile/ProductTile'

const BottomSection = () => {
    const dataCms:
        | Maybe<Array<Maybe<CmsBlock>>>
        | undefined = CMSBlockValueGet()

    return (
        <>
            {dataCms && ProductItem ? (
                <>
                    <div className={s['shopBlog']}>
                        <div className={s['container-classes']}>
                            <div className={s['shopBloglist']}>
                                <RichContent
                                    html={getCMSBlock(
                                        CMSConfigConst.SHOP_NOW,
                                        dataCms
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={s['upsellSlider']}>
                        <div className={s['container-classes']}>
                            <RichContent
                                html={getCMSBlock(
                                    CMSConfigConst.YOU_MAY_LIKE_SLIDER,
                                    dataCms
                                )}
                                ProductTile={ProductItem}
                            />
                        </div>
                    </div>
                </>
            ) : null}
        </>
    )
}

export default BottomSection
